import memoize from '@configuratorware/configurator-frontendgui/Utils/Function/memoize';

export const getComponent = (configuration, componentIdentifier) =>
  configuration?.optionclassifications?.find(({ identifier }) => componentIdentifier === identifier);

export const getOption = (component, optionIdentifier) =>
  component?.selectedoptions?.find(({ identifier }) => optionIdentifier === identifier);

export const getOptionInputValue = (option) => option?.inputText;

export const getSelectedOptions = (component) => component?.selectedoptions || [];

export const getFrameHeight = (configuration, wallHeight) => {
  const frameOption = getSelectedOptions(getComponent(configuration, 'door_frame'))[0];
  return frameOption?.identifier === 'door_frame_room_height' ? wallHeight : Math.min(2.2, wallHeight);
};

export const getDoorType = (configuration) => {
  return configuration.optionclassifications.find(({ identifier }) => identifier === 'door_types')
    ?.selectedoptions?.[0];
};

export const hasAttributeWithValue = (attributes, attributeIdentifier, attributeValue) =>
  attributes.some(
    ({ identifier, values }) =>
      identifier === attributeIdentifier && values.some(({ value }) => value === attributeValue)
  );

export const removeHiddenComponents = memoize((components) =>
  components.filter(
    ({ hiddenInFrontend, attributes }) =>
      !hiddenInFrontend && !hasAttributeWithValue(attributes, 'hidden_in_frontend', true)
  )
);

export const withEnabledState = memoize((components, checkedComponents) =>
  components.map((component, idx, arr) => ({
    ...component,
    enabled: checkedComponents[arr[idx].identifier],
  }))
);
